export const ROW_HEIGHT = 25
export const ROW_WIDTH = 20
export const LOGOUT_ERRORS = [401]
